<template>
	<div class='application-wrap'>
		<div class="application-top">
			<div class="application-title">网站声明</div>
			<div class="application-form"><span>来源：--</span><span>时间：2017-11-03</span></div>
		</div>
		<div class="application-content">
			<div class="">信用肥城网站（以下简称“信用肥城”）提醒您：在浏览、使用信用肥城网站与服务前，请您务必仔细阅读并透彻理解本声明。如果您使用信用肥城网站与服务，您的使用行为将被视为对本声明全部内容的认可。</div>
			<div class="">除另有特别声明外，信用肥城网站提供本网站服务时所依托软件的著作权、专利权及其他知识产权均归信用肥城所有。上述及其他任何本网站包含的内容的知识产权均受到法律保护，未经信用肥城网站、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。</div>
			<div class="">信用肥城充分尊重作者的知识产权，对于转发的稿件，均注明作者，指明出处。如果您对信用肥城网站刊用您的稿件存有异议，请及时通知我们，如涉嫌侵权，我们将立即移除相关稿件。</div>
			<div class="">信用肥城充分尊重作者的知识产权，对于转发的稿件，均指明出处。如果各相关机构或个人对信用肥城网站刊用贵机构或个人的稿件存有异议，请及时通知我们，如涉嫌侵权，一旦查证属实，我们将立即移除相关稿件。</div>
			<div class="">任何单位或个人认为通过信用肥城提供的内容涉嫌侵犯其信息网络传播权或其他合法权益，应该及时向信用肥城提出书面权利通知，并提供身份证明、权属证明及详细侵权情况证明。信用肥城在收到上述法律文件后，将会依法尽快断开相关链接内容。</div>
			<div class="">
				为用户提供权威信用数据查询服务，是信用肥城一直努力追求的目标，但您知悉并理解，使用信用肥城查询模块所查询出的结果内容可能由第三方提供，信用肥城无法对其提供内容的合法性、真实性、准确性进行一一核实，亦对第三方提供的内容本身不承担任何法律责任。若您对查询结果存有异议，请与信息提供方直接沟通处理，信用肥城将在网站中详细标注各种信息的具体来源。同时，在确认相关查询结果内容确需修改的，也欢迎您及时与信用肥城联系，您的监督与支持是我们不断改进服务的动力。
			</div>
			<div class="">用户在信用肥城使用上述第三方提供的产品或服务时（如有），除遵守本协议约定外，还应遵守第三方的用户协议。信用肥城和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</div>
			<div class="">除非信用肥城书面许可，任何单位和个人不得从事下列任一行为：</div>
			<div class="">（1）对信用肥城进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本网站的源代码；</div>
			<div class="">（2）对信用肥城拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</div>
			<div class="">
				（3）对信用肥城或者浏览网站过程中释放到任何终端内存中的数据、网站运行过程中客户端与服务器端的交互数据，以及网站运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经信用肥城授权的第三方工具/服务接入网站和相关系统；</div>
			<div class="">（4）通过修改或伪造网站运行中的指令、数据，增加、删减、变动网站的功能或运行效果，或者将用于上述用途的网站、方法进行运营或向公众传播，无论这些行为是否为商业目的；</div>
			<div class="">（5）通过非信用肥城开发、授权的第三方网站、插件、外挂、系统，登录或使用信用肥城网站及服务，或制作、发布、传播非信用肥城开发、授权的第三方网站、插件、外挂、系统。</div>
		</div>
	</div>
</template>

<script>

export default {
	components: {},
	data() {
		return {}
	},
	created() { },
	mounted() { },
	methods: {},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' scoped>
	.application-wrap {
		width: 1200px;
		margin: 0 auto;
		padding: 20px 0;
		& > .application-top {
			width: 100%;
			height: 100px;
			& > .application-title {
				width: 300px;
				text-align: center;
				line-height: 90px;
				margin: 0 auto;
				color: #1d1d1d;
				font-size: 16px;
			}
			& > .application-form {
				width: 500px;
				height: 30%;
				text-align: center;
				line-height: 30%;
				margin: 0 auto;
				padding-left: 3%;
				span {
					color: #afb0b0;
					display: inline-block;

					& + span {
						margin-left: 100px;
					}
				}
			}
		}

		.application-content {
			border-top: 1px solid #e7edf3;
            margin-top: 10px;
			text-align: left;
			padding-top: 15px;
			& > div {
				color: #7a797c;
				line-height: 33px;
			}
		}
	}
</style>